import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { MESSAGES, waLink } from "@/data/content";

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href={waLink(MESSAGES.general)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="تواصل عبر واتساب"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-copper text-navy shadow-[0_10px_30px_rgba(10,25,47,0.35)] transition-transform duration-300 hover:scale-110 lg:hidden"
    >
      <span
        className="absolute inset-0 animate-ping rounded-full bg-copper/40 [animation-duration:2.5s]"
        aria-hidden="true"
      />
      <MessageCircle className="relative h-6 w-6" />
    </motion.a>
  );
}
